import { ALL_LEVEL_OPTIONS } from "./assessmentToLevelMapping";

export const FILTERS = {
  school: {
    id: "SchoolIDs",
    label: "School",
    placeholder: "All Schools",
    defaultValue: [],
    // optionsList: schoolOptions,
    isMulti: true,
    showSelectAll: false,
    isFilter: true,
  },
  year: {
    id: "Years",
    label: "Year",
    placeholder: "All Years",
    defaultValue: [],
    // optionsList: yearOptions,
    isMulti: true,
    showSelectAll: false,
    isFilter: true,
  },
  grade: {
    id: "GradeIDs",
    label: "Grade",
    placeholder: "All Grades",
    defaultValue: [],
    optionsList: [
      // { value: "", label: "All Grades" },
      { value: 7, label: "Kindergarten" },
      { value: 1, label: "Grade 1" },
      { value: 2, label: "Grade 2" },
      { value: 3, label: "Grade 3" },
      { value: 4, label: "Grade 4" },
      { value: 5, label: "Grade 5" },
      { value: 6, label: "Grade 6" },
      { value: 8, label: "Grade 7" },
      { value: 9, label: "Grade 8" },
      { value: 10, label: "Other" },
    ],
    isMulti: true,
    showSelectAll: false,
    isFilter: true,
  },
  level: {
    id: "LevelIDs",
    label: "Level",
    placeholder: "All Levels",
    defaultValue: [],
    optionsList: ALL_LEVEL_OPTIONS,
    isMulti: true,
    showSelectAll: false,
    isFilter: true,
  },
  assessment: {
    id: "CategoryIDs",
    label: "Assessment",
    placeholder: "All Assessments",
    defaultValue: [],
    optionsList: [
      { value: 2, label: "Letter Sounds" },
      { value: 1, label: "Name the Letter" },
      { value: 3, label: "Story Reading" },
      { value: 4, label: "Silly Words" },
      { value: 5, label: "Break up the word" },
      { value: 6, label: "Say the first Sound" },
    ],
    isMulti: true,
    showSelectAll: false,
    isFilter: true,
  },
  benchmark: {
    id: "BenchMarkIDs",
    label: "Benchmark",
    placeholder: "All Benchmarks",
    defaultValue: [],
    optionsList: [
      // { value: "", label: "Please Select a Benchmark" },
      { value: 1, label: "Benchmark – Fall" },
      { value: 2, label: "Benchmark – Winter" },
      { value: 3, label: "Benchmark – Spring" },
    ],
    isMulti: true,
    showSelectAll: false,
    isFilter: true,
  },
  role: {
    id: "UserTypeIDs",
    label: "Role",
    placeholder: "All Roles",
    defaultValue: [],
    optionsList: [
      { value: 1, label: "Teacher" },
      { value: 2, label: "Student" },
    ],
    isMulti: true,
    showSelectAll: false,
    isFilter: true,
  },
  benchmarkStatus: {
    id: "BenchMarkStatusIDs",
    label: "BenchmarkStatus",
    placeholder: "Select Benchmark Status",
    defaultValue: [],
    optionsList: [
      { value: 1, label: "Above Benchmark" },
      { value: 2, label: "At Benchmark" },
      { value: 3, label: "Below Benchmark" },
      { value: 4, label: "Well Below Benchmark" },
    ],
    isMulti: true,
    showSelectAll: false,
    isFilter: true,
  },
};
